// Spanish for the calendar area: Job Calendar tab (EmbeddedCalendar.js),
// Availability tab (AvailabilityView.js), time off chips/popup
// (TimeOffCalendarPieces.js) and the tech "Mark as completed" flow
// (utils/techCompletion.js). English text (exact) -> Spanish.
const dict = {
  /* ---------- tabs / legend ---------- */
  "Month": "Mes",
  "Week": "Semana",
  "Day": "Día",
  "Availability": "Disponibilidad",
  "Calendar Legend:": "Leyenda del Calendario:",
  "Proposal": "Propuesta",
  "Meeting / Inspection": "Reunión / Inspección",
  "Action Item": "Tarea Pendiente",
  "All Other Jobs": "Todos los Demás Trabajos",
  "Completed / Invoice Sent": "Completado / Factura Enviada",
  "Untitled Job": "Trabajo sin nombre",
  "WO#": "OT#",
  "ANY": "Cualquier hora",
  "Monthly": "Mensual",

  /* ---------- job details popup ---------- */
  "Job Details": "Detalles del Trabajo",
  "Site Name:": "Nombre del Sitio:",
  "Work Order:": "Orden de Trabajo:",
  "Address:": "Dirección:",
  "City:": "Ciudad:",
  "State:": "Estado:",
  "Start Date:": "Fecha de Inicio:",
  "End Date:": "Fecha Final:",
  "Start Time:": "Hora de Inicio:",
  "End Time:": "Hora Final:",
  "Service Type:": "Tipo de Servicio:",
  "Scope:": "Alcance:",
  "Job Description:": "Descripción del Trabajo:",
  "Planned:": "Planeado:",
  "{n} day(s)": "{n} día(s)",
  "{n} people": "{n} personas",
  "Client Phone:": "Teléfono del Cliente:",
  "Client Email:": "Correo del Cliente:",
  "Tech Assign:": "Técnicos Asignados:",
  "Status:": "Estado:",
  "Materials": "Materiales",
  "Mark material as not purchased": "Marcar material como no comprado",
  "Mark material as purchased": "Marcar material como comprado",
  "Purchased — click to undo": "Comprado — toque para deshacer",
  "Not purchased — click when purchased": "No comprado — toque cuando lo compre",
  "Unnamed Material": "Material sin nombre",
  "Qty:": "Cant.:",
  "Cost Per:": "Costo por Unidad:",
  "Estimated Material Cost:": "Costo Estimado del Material:",
  "Purchase Location:": "Lugar de Compra:",
  "Not entered": "No ingresado",
  "Purchased": "Comprado",
  "Not Purchased": "No Comprado",
  "Material Notes:": "Notas del Material:",
  "Total Estimated Material Cost:": "Costo Total Estimado de Materiales:",
  "No materials listed.": "No hay materiales en la lista.",
  "Attachment {n}": "Archivo adjunto {n}",
  "View File {n}": "Ver Archivo {n}",
  "No notes yet.": "Todavía no hay notas.",
  "Supervisor": "Supervisor",
  "History": "Historial",
  "Add / Change Total": "Agregar / Cambiar Total",
  "Add Note": "Agregar Nota",
  "Check in to this job first.\n\nTap Check In when you arrive so your time and location are recorded, then mark it completed.":
    "Primero registre su llegada a este trabajo.\n\nToque Registrar Llegada cuando llegue para que se guarden su hora y ubicación, y después márquelo como completado.",
  "Sent to Office ✓": "Enviado a la Oficina ✓",
  "Mark Job as Completed": "Marcar Trabajo como Completado",
  "Add Receipt": "Agregar Recibo",
  "Add / Edit Materials": "Agregar / Editar Materiales",
  "Checklist": "Lista de Verificación",

  /* ---------- materials popup ---------- */
  "No materials have been added.": "No se han agregado materiales.",
  "Material {n}": "Material {n}",
  "Remove Material": "Quitar Material",
  "Product": "Producto",
  "Product or material name": "Nombre del producto o material",
  "Qty": "Cant.",
  "Unit": "Unidad",
  "pcs, ft, bags": "pzas, pies, bolsas",
  "Cost Per": "Costo por Unidad",
  "Estimated Material Cost": "Costo Estimado del Material",
  "Purchase Location": "Lugar de Compra",
  "Home Depot, Lowe's, supplier, etc.": "Home Depot, Lowe's, proveedor, etc.",
  "Material Notes": "Notas del Material",
  "Sizes, model numbers, colors, special instructions, etc.":
    "Medidas, números de modelo, colores, instrucciones especiales, etc.",
  "Photos / Files": "Fotos / Archivos",
  "Remove file": "Quitar archivo",
  "Add Material": "Agregar Material",
  "Save Materials": "Guardar Materiales",

  /* ---------- notes ---------- */
  "Enter your note here...": "Escriba su nota aquí...",
  "Saving note...": "Guardando nota...",

  /* ---------- alerts ---------- */
  "Could not update the material purchase status.": "No se pudo actualizar el estado de compra del material.",
  "Could not mark job completed. Please try again.":
    "No se pudo marcar el trabajo como completado. Intente de nuevo.",
  "There was an error saving your note. Please try again.":
    "Hubo un error al guardar su nota. Intente de nuevo.",

  /* ---------- Availability tab ---------- */
  "All Day": "Todo el Día",
  "All Day (day {n} of {total})": "Todo el Día (día {n} de {total})",
  "View job details": "Ver detalles del trabajo",
  "Previous week": "Semana anterior",
  "Prev": "Anterior",
  "Next week": "Semana siguiente",
  "Techs ({n})": "Técnicos ({n})",
  "Loading staff…": "Cargando personal…",
  "Reset to default": "Restablecer",
  "Days of the week": "Días de la semana",
  "{n} job": "{n} trabajo",
  "{n} jobs": "{n} trabajos",
  "{n} open@@slot": "{n} libres",
  "Open — click to schedule": "Libre — toque para programar",
  "Booked — click for details": "Ocupado — toque para ver detalles",
  "Time off": "Tiempo libre",
  "Past": "Pasado",
  "No tech assigned": "Sin técnico asignado",
  "No techs selected. Click Techs to pick who to show.":
    "No hay técnicos seleccionados. Toque Técnicos para elegir a quién mostrar.",
  "Leaving early": "Sale temprano",
  "Coming in late": "Llega tarde",
  "Schedule an all-day job (construction)": "Programar un trabajo de todo el día (construcción)",
  "All day job": "Trabajo de todo el día",
  "Booked all day — view job": "Ocupado todo el día — ver trabajo",
  "Booked all day": "Ocupado todo el día",
  "Schedule {name}, {time}": "Programar a {name}, {time}",
  "Open@@slot": "Libre",

  /* ---------- time off on the calendar ---------- */
  "Someone": "Alguien",
  "Left early": "Salió temprano",
  "Came in late": "Llegó tarde",
  "Called out": "Faltó (avisó)",
  "No call / no show": "No avisó / no se presentó",
  "Left early at {time}": "Salió temprano a las {time}",
  "Came in late at {time}": "Llegó tarde a las {time}",
  "Leaving early at {time}": "Sale temprano a las {time}",
  "Coming in late at {time}": "Llega tarde a las {time}",
  "Approved time off": "Tiempo libre aprobado",
  "Approved leave early / late": "Salida temprano / llegada tarde aprobada",
  "Left early / came in late": "Salió temprano / llegó tarde",
  "Out / partial day ({n})": "Ausentes / día parcial ({n})",
  "Attendance": "Asistencia",
  "Time Off": "Tiempo Libre",
  "Name:": "Nombre:",
  "Date:": "Fecha:",
  "Dates:": "Fechas:",
  "What happened:": "Qué pasó:",
  "Type:": "Tipo:",
  "Notice given:": "Aviso dado:",
  "After the fact": "Después del hecho",
  "Same day": "El mismo día",
  "Night before": "La noche anterior",
  "Day before": "El día anterior",
  "{n} days ahead": "{n} días antes",
  "Told us:": "Nos avisó:",
  "Logged by:": "Registrado por:",
  "Paid time type:": "Tipo de tiempo pagado:",
  "Vacation": "Vacaciones",
  "Personal": "Personal",
  "Requested:": "Solicitado:",
  "Reasons and notes are on the Time Off Approvals page.":
    "Los motivos y notas están en la página de Aprobación de Tiempo Libre.",

  /* ---------- tech "mark as completed" (utils/techCompletion.js) ---------- */
  "No job selected.": "No hay trabajo seleccionado.",
  "Sent to the office as completed on {when}. Waiting for the office to finish it.":
    "Enviado a la oficina como completado el {when}. Esperando que la oficina lo termine.",
  "Sent to the office as completed. Waiting for the office to finish it.":
    "Enviado a la oficina como completado. Esperando que la oficina lo termine.",
  "Sent back by {name}": "Devuelto por {name}",
  "the office": "la oficina",
  "Fix it and mark it completed again.": "Corríjalo y márquelo como completado otra vez.",
  "The office completed this job.": "La oficina completó este trabajo.",
  "Could not send this to the office. Please try again.":
    "No se pudo enviar a la oficina. Intente de nuevo.",
  "Mark job as completed?": "¿Marcar el trabajo como completado?",
  "This sends the job to the office so they can finish it and make the invoice. Your calendar won't change.":
    "Esto envía el trabajo a la oficina para que lo terminen y hagan la factura. Su calendario no cambiará.",
  "Note for the office (optional)": "Nota para la oficina (opcional)",
  "Anything they should know before invoicing": "Algo que deban saber antes de facturar",
  "Sending...": "Enviando...",
  "Yes, send to office": "Sí, enviar a la oficina",
};

export default dict;
